import { createContext } from 'react';

export const InsuranceContainerContext = createContext({
  b2bClientKey: ''
});
